'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { overlay } from './Modal.css';

const Modal = ({
  children,
  onRequestClose,
  visible = false,
  full,
}: {
  children: React.ReactNode;
  onRequestClose?: () => void;
  visible?: boolean;
  full?: boolean;
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!visible || !mounted || typeof document === 'undefined') return null;

  return createPortal(
    <div className={overlay} style={{ padding: full ? '0' : '10vh 8px' }} onClick={onRequestClose}>
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </div>,
    document.body,
  );
};

export default Modal;
